import { useAuth } from './use-auth';
import { Workspace } from '@/lib/types';

export default function useWorkspace() {
  const auth = useAuth();
  return {
    workspace: auth.workspace as Workspace,
  };
}
